var map = {
	"./africa/game.vue": [
		"CdZi",
		16
	],
	"./club-soft/game.vue": [
		"iw0X",
		17
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Ogzi";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/pages/game lazy ^\.\/.*\/game\.vue$
// module id = Ogzi
// module chunks = 37